<template>
  <div>
    <a-row>
      <g-master :name="master.endpoint"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                @action="masterAction"
      >
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-dropdown :label="$t('Tallas')"
                          :selectConfig="{mode:'multiple'}"
                          :formItemConfig="fiOptions"
                          endpoint="hierarchy_lookup"
                          :params="tallas"
                          :disabled="isedit"
                          :decorator="['garment_size']">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Estado')" >
                <a-checkbox
                  v-decorator="['status', {valuePropName: 'checked' , rules: [{ required: false}]}]">
                </a-checkbox>
              </a-form-item>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    props: ['id_garment_type'],
    data () {
      return {
        isedit: false,
        tallas: {
          h_lookup_type: 'TIPO_PRENDA_TALLA'
        },
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'garment_size_dot',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: '#', dataIndex: 'id', sorter: true},
              {title: 'Talla', dataIndex: 'talla_desc', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'status'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_garment_type: this.id_garment_type
        }
      }
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'fieldsChange':
            this.isedit = true
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Dotaciones/GarmentSizeDot.vue